/**
 * When is a question type "weak"? One answer, used by the student's practice
 * hub, their home-page nudge and the teacher's view of the same student
 * (Phase 175) — three screens that must never disagree about the threshold.
 */

/** Below this many answers a percentage is noise, not a signal. */
export const MIN_ANSWERS_FOR_ACCURACY = 10;
/** At or below this, and with enough answers to mean it, the type is "weak". */
export const WEAK_ACCURACY_THRESHOLD = 60;

export function isWeak(card: { accuracy: number | null; answered: number }): boolean {
  return (
    card.accuracy !== null &&
    card.answered >= MIN_ANSWERS_FOR_ACCURACY &&
    card.accuracy < WEAK_ACCURACY_THRESHOLD
  );
}
